var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{attrs:{"name":"generical-modal","width":'188px',"height":'auto',"styles":"border-radius: 10px;"}},[_c('div',{staticClass:"accept-title"},[_c('div',{staticClass:"check--icon"},[_c('CheckIcon',{attrs:{"size":"32","color":"#FFFFFF"}})],1),_c('p',{staticClass:"text"},[_vm._v(_vm._s(_vm.loadingText))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }